// extracted by mini-css-extract-plugin
module.exports = {"container":"customAd_container__cu73x"};